var isObject = require('is-object')
var isWindow = require('is-window')

function isNode (val) {
  if (!isObject(val) || !isWindow(window) || typeof window.Node !== 'function') {
    return false
  }

  return typeof val.nodeType === 'number' &&
    typeof val.nodeName === 'string'
}

module.exports = isNode



//////////////////
// WEBPACK FOOTER
// ./~/is-dom/index.js
// module id = 414
// module chunks = 0 1 2 3 4